import { post, del } from '@/common/request';

const roleSetMap = new Map([
  ['list', '/tenant/role/page'],
  ['add', '/tenant/role/create'],
  ['delete', '/tenant/role/delete'],
  ['edit', '/tenant/role/update'],
  ['batch', '/tenant/role/relation/batchAssign'],
  ['updateSingleUser', '/tenant/role/updateSingleUser'],
  ['singleBatch', '/tenant/role/relation/assign']
]);

interface SearchParams {
  name?: string;
  type?: number;
};

export interface RoleInfo {
 id?: number;
 name?: string,
 type?: number[]
 typeName?: string,
 multiSelect?: number
}

interface Response {
  pageNum?: number;
  pageSize?: number;
  objectList?: RoleInfo[];
}


export function getList(page: number, size: number, searchParams?: SearchParams): Promise<Response> {
  return post('/tenant/role/page', { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
}

export function remove(id: number) {
  return del(`/property/resource_roles/${id}`, { }, { needHint: true });
}

export function updateSingUser(id:number, multiSelect: number) {
  return post(roleSetMap.get('/tenant/role/updateSingleUser'), { id, multiSelect }, { proxyApi: '/resserv', needHint: true });
}

export function batch(type: 0 | 1, tenantPlaceIdList: any[], tenantSpotIdList: any[], roleRelationList: any[]) {
  return post('/tenant/role/relation/batchAssign', { type, tenantPlaceIdList, tenantSpotIdList, roleRelationList }, { proxyApi: '/resserv', needHint: true });
}

// type: 1 | 0, tenantPlaceId: any[], tenantSpotId: any, roleId, employeeIdList: any[]
export function postSingleBatch(params) {
  return post('/tenant/role/relation/assign', params, { proxyApi: '/resserv', needHint: true });
}



export default roleSetMap;
